import React, { useEffect,useRef} from "react";
import ScreenResize from "../Contenido/ScreenResize/ScreenResize";
import './../../../node_modules/bootstrap/dist/css/bootstrap.css';
import normatecaStore from "../../stores/normatecaStore";
import Acoordion from "./../Contenido/MenuAcoordion/Acoordion";
import AcoordionMovil from "./../Contenido/MenuAcoordion/AcoordionMovil";
import Encuesta from "./../Encuesta/Encuesta";

export default function Encabezado(){
    const imgurl = process.env.REACT_APP_IMG_URL; 
    const home = process.env.REACT_APP_HOME_URL;
    

    const screen= ScreenResize();
       // store - zuntand
       const { menuEncabezado,getMenuEncabezado,setMasConsultado,setVisMenuP,visEnc,setError} =
       normatecaStore((state) =>( { 
         menuEncabezado:state.menuEncabezado,
         getMenuEncabezado:state.getMenuEncabezado,
         setMasConsultado:state.setMasConsultado,
         setVisMenuP: state.setVisMenuP,
         visEnc: state.visEnc,
         setError:state.setError
     })); 
    useEffect(() => { 
        getMenuEncabezado().then(function(data){
            if(data==="Error"){
                setError().catch(null);
            }
            let pathname = window.location.pathname;
            if (!pathname.includes("menu") && !pathname.includes("masinfo") && !pathname.includes("q") && !pathname.includes("busAvaOpc") && !pathname.includes("qa")){
                setMasConsultado().catch(null);
            }
        });        
     },[]);  
     useEffect(() => {
        document.addEventListener("click", clickOutsideMJ, false);
        return () => {
        document.removeEventListener("click", clickOutsideMJ, false);
        };
   }, []);
   const menu = useRef(null);
   const clickOutsideMJ = event => {
       if (menu.current && !menu.current.contains(event.target)) {
            setVisMenuP("123").catch(null);
        }
    };
          
    return (
        <div className="encabezado">
       
            <div className="padding-1 margin-right0 display-flex">
                <div className="divImgNorm display-flex">
                    {/* onClick={()=>cambiaContenido(0, "0","Inicio")} */}
                    <div><a href={home}  className="aEnc" target="_self"><img src={imgurl + "normateca/normateca.png"} className="widthImgNorm"/></a></div>
                    {screen.width<=974?
                        <div className="divImgINEGI padleft-2EncMovil"><a href="https://www.inegi.org.mx" target="_blank"><img src={imgurl + "home/inegi.svg" } className="width-150px"/></a></div>
                    :null
                    }
                </div>
                
                <div className="colMenu"  ref={menu} >
{/*                     <button type="button" onClick={()=>setVisualizaMenuMovil(visualizaMenuMovil? false:true)} className="expand-menu"><span className="inegi-menudesplegable imgMenuLat " ></span></button>
 */}               {/*  <div className="expand-menu">
                    <span className='expand-menu-text' >Menu</span>
                    <label htmlFor='cb-menu' id='lbl-menu'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 124 124"><g fill="#0d7eff"><path d="M112 6H12C5.4 6 0 11.4 0 18s5.4 12 12 12h100c6.6 0 12-5.4 12-12s-5.4-12-12-12zM112 50H12C5.4 50 0 55.4 0 62s5.4 12 12 12h100c6.6 0 12-5.4 12-12s-5.4-12-12-12zM112 94H12c-6.6 0-12 5.4-12 12s5.4 12 12 12h100c6.6 0 12-5.4 12-12s-5.4-12-12-12z"/></g></svg></label>
                </div> */}
                   {screen.width<=974? 
                     <div className="display-flex">
                         <div style={{zIndex: visEnc? '1050' : '1047'}}><Encuesta/></div> 
                         <div id="acmov" className="width-13rem" ><AcoordionMovil ubi="menuNav" menu={menuEncabezado} indi=""/></div>
                     </div>
                   :
                    <div className="display-flex">
                            <div id="menuMJ" className="width-10rem" ><Acoordion ubi="menuNav" menu={menuEncabezado[0]} indi="1" /></div>
                            <div id="menuMN" className="width-13rem" ><Acoordion ubi="menuNav" menu={menuEncabezado[1]} indi="2" /></div>
                            <div id="menuMa" className="width-10rem" ><Acoordion ubi="menuNav" menu={menuEncabezado[2]} indi="3" /></div>
                    </div>
                   }
                </div>
                {screen.width>974?
                 <div  >
                    <div className="divImgINEGI"><a href="https://www.inegi.org.mx" target="_blank"><img src={imgurl + "home/inegi.svg" } className="width-150px"/></a></div>
                </div> 
                :null
                }
            </div>
          
        </div>
    )
}